import { fbDB } from "../config/firebase";
import { QUIZ4_FEEDBACK_ADD, QUIZ4_ONGOING_UPDATE } from "./types";

export const quiz4FeedbackAdd = data => async dispatch => {
  return dispatch({
    type: QUIZ4_FEEDBACK_ADD,
    payload: data.map(d => ({
      currentClass: d.currentClass,
      name: d.name,
      uid: d.uid,
      onGoing: d["classCode"][d.currentClass]["quiz4OnGoing"]
    }))
  });
};

/**
 *
 * @param {*} uid
 * @param {*} cClass
 * @param {array} feedbacks
 */
export const quiz4OnGoingUpdate = (
  uid,
  cClass,
  feedbacks
) => async dispatch => {
  fbDB
    .ref(`/users/${uid}/classCode/${cClass}/quiz4OnGoing/feedbacks`)
    .update(feedbacks)
    .then(() => {
      return dispatch({
        type: QUIZ4_ONGOING_UPDATE,
        payload: null
      });
    })
    .catch(err => {
      console.log(err);
    });
};
